<div class="question-section-list">
  <qai-dragable
    [items]="questionItems"
    [gap]="'var(--spacing-xl)'"
    [useDragHandle]="true"
    [dragHandleDisable]="readOnly"
    (itemsChange)="onQuestionsReordered($event)"
    class="question-list"
  >
    <ng-template #cardTemplate let-item>
      <knowledge-check-question-panel
        [questionForm]="asFormGroup(item)"
        [draggable]="isSaved(asFormGroup(item))"
        [deleting]="isDeleting(asFormGroup(item))"
        [initialExpanded]="opensExpanded(asFormGroup(item))"
        [shouldStartEditing]="isAddedQuestion(asFormGroup(item))"
        [answerPointListId]="answerPointListId(asFormGroup(item))"
        [connectedAnswerPointListIds]="connectedAnswerPointListIds(asFormGroup(item))"
        (deleteRequested)="deleteQuestion(asFormGroup(item))"
        (answerPointsReordered)="onAnswerPointsReordered(asFormGroup(item), $event)"
      />
    </ng-template>
  </qai-dragable>

  <span class="add-question" #addQuestionBtnWrapper>
    <button
      qai-button
      [shape]="'normal'"
      [kind]="'tertiary'"
      [size]="'medium'"
      [disabled]="readOnly || !questions || hasBlankQuestion()"
      (click)="addQuestion()"
    >
      <qai-icon kind="plus" size="20px" positionStart />
      <span>{{ 'simulationBuilder.KNOWLEDGE_CHECK_ADD_NEW_QUESTION' | transloco }}</span>
    </button>
  </span>
  @if (hasBlankQuestion()) {
    <qai-tooltip [qaiFloating]="addQuestionBtnWrapper" [placement]="'above-center'" [events]="['hover']">
      {{ 'simulationBuilder.KNOWLEDGE_CHECK_BLANK_QUESTION_TOOLTIP' | transloco }}
    </qai-tooltip>
  }
</div>
